import styled, { css } from 'styled-components';
import { Layout } from 'antd'

type Props = {
    isRelative?: boolean;
    minHeight?: number;
};

export const Content = styled(Layout.Content)<Props>`
    ${({ isRelative }) => isRelative && css`
        position: relative;
    `}

    ${({ minHeight }) => minHeight && css`
        min-height: ${minHeight}px;
    `}

    @media(max-width: 768px) {
        padding: 0px;
        margin-top: 20px;
        margin-bottom: 100px;
    }

    @media(max-width: 768px) {
        &.page {
            padding-bottom: 50px;
            margin-bottom: 290px;
        }
    }

    /* Tela da prova: o rodapé Anterior/Próximo já fica logo após o conteúdo da questão,
       então a folga genérica de 290px do .page (dimensionada para outras telas) sobra
       demais aqui — mantém só o suficiente para não ficar atrás do menu fixo inferior. */
    @media(max-width: 768px) {
        &.page.lecture-page {
            margin-bottom: 24px;
        }
    }
`;